import { RangeHourService } from '@services/range-hour/range-hour.service';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DsconfigService } from './dsconfig/dsconfig.service';
import { ErrorService } from './error/error.service';
import { LoadingService } from './loading/loading.service';
import { ObservatoryService } from './observatory/observatory.service';
import { RestConnService } from './rest-conn/rest-conn.service';
import { StorageService } from './storage/storage.service';
import { UserService } from './user/user.service';
import { CookieService } from './cookie/cookie.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { AuthService } from './auth/auth.service';
import { FileExporterService } from './file-Exporter/file-exporter.service';
import { NotificationsService } from './notifications/notifications.service';
import { UtilsService } from '@services/utils/utils.service';
/**
 * Modulo que incorpora todos los servicios globales de la página.
 * Al dar de alta un nuevo servicio global, este tendrá que ser exportado al final de este fichero
 * ejemplo: export * from './loading/loading.service';
 */
@NgModule({
  imports: [CommonModule],
  declarations: [],
  entryComponents: [],
  providers: [
    RangeHourService,
    DsconfigService,
    ErrorService,
    LoadingService,
    ObservatoryService,
    RestConnService,
    UserService,
    UtilsService,
    CookieService,
    StorageService,
    TranslateService,
    HttpClientModule,
    AuthService,
    FileExporterService,
    NotificationsService
  ],
  exports: [
  ],
})
export class ServicesModule {}

 export * from './dsconfig/dsconfig.service';
 export * from './error/error.service';
 export * from './loading/loading.service';
 export * from './observatory/observatory.service';
 export * from './rest-conn/rest-conn.service';
 export * from './storage/storage.service';
 export * from './user/user.service';
 export * from './cookie/cookie.service';
 export * from './auth/auth.service';
 export * from './file-Exporter/file-exporter.service';
 export * from './notifications/notifications.service';
 export * from './utils/utils.service';
